exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-080d70a3] {\n  border: 1px solid #d7d8da;\n}\n.table th[data-v-080d70a3], .table td[data-v-080d70a3] {\n  font-size: 12px;\n}", ""]);

// exports
